import { useLocation } from "react-router-dom";
import Image from "components/layouts/Image/Image";
import Title from "components/typography/Title/Title";
import { verizonLogo } from "assets";
import paths from "routing/paths";
import { HeaderWrapper } from "./UnprotectedHeader.module";

const getPageTitle = (pathname: string) => {
  if (pathname === paths.FORGOT_PASSWORD) {
    return "Reset Password";
  }

  if (pathname === paths.SIGNUP) {
    return "Create your Brand Central account";
  }

  return "Brand Central";
};

const UnprotectedHeader = () => {
  const { pathname } = useLocation();
  const title = getPageTitle(pathname);

  return (
    <HeaderWrapper>
      <Image src={verizonLogo} width="13.5rem" />
      <Title size="XLarge" bold color="#EE0000" pd="4rem 0 2rem 0">
        {title}
      </Title>
    </HeaderWrapper>
  );
};

export default UnprotectedHeader;
